//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppFooterCTA',

  computed: mapGetters('user', ['isLoggedIn'])
}
